module.exports = __webpack_public_path__ + "assets/media/m-2.30a5b96b.svg";